/* Native Style Profile editor. Public dictionaries feed the choices; only the
   signed-in owner's profile row and avatar folder can be changed. */

(function () {
  var SESSION_KEY = 'gettmi:session:v1';
  var state = {
    activeSection: '',
    brands: [],
    creatorMode: 'az',
    creators: [],
    loaded: false,
    loading: false,
    options: {},
    profile: {},
    query: '',
    selected: {
      brands: [],
      budgets: [],
      colours: [],
      creators: [],
      details: [],
      dislikes: [],
      fit: [],
      occasions: [],
      openingFeed: [],
      shoeSizes: [],
      sizes: [],
      suggestedCreators: []
    },
    unsaved: false
  };
  var sectionDefinitions = {
    brands: { title: 'Favourite brands' },
    openingFeed: { title: 'Opening feed', dimension: 'opening_feed', selected: 'openingFeed' },
    sizes: { title: 'Sizes' },
    occasions: { title: 'What you shop for', dimension: 'occasion', selected: 'occasions' },
    colours: { title: 'Colours and details' },
    fit: { title: 'Fit preferences', dimension: 'fit', selected: 'fit' },
    budget: { title: 'Price range', dimension: 'budget', selected: 'budgets' },
    notMyStyle: { title: 'Not my style', dimension: 'dislike', selected: 'dislikes' }
  };

  function settingsRoot() {
    return document.querySelector('[data-gettmi-settings]');
  }

  function view() {
    var settings = settingsRoot();
    return settings && settings.querySelector('[data-gettmi-style-profile]');
  }

  function config() {
    var el = document.querySelector('[data-gettmi-supabase]');
    return el ? { url: el.dataset.supabaseUrl, key: el.dataset.supabaseKey } : null;
  }

  function session() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function styleProfileGated() {
    return Boolean(
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.isEnabled === 'function' &&
      window.GettmiAppGate.isEnabled('style_profile')
    );
  }

  function authHeaders(currentSession, extra) {
    var cfg = config();
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + currentSession.access_token
    }, extra || {});
  }

  function el(tag, className, textValue) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof textValue !== 'undefined') node.textContent = textValue;
    return node;
  }

  function asArray(value) {
    return Array.isArray(value) ? value.filter(Boolean) : [];
  }

  function openStyleProfile() {
    if (styleProfileGated()) return;
    var settings = settingsRoot();
    var styleView = view();
    if (!settings || !styleView) return;
    settings.querySelectorAll('[data-gettmi-account-view]').forEach(function (accountView) {
      accountView.hidden = accountView !== styleView;
    });
    var accountCenter = settings.querySelector('[data-gettmi-account-center]');
    if (accountCenter) accountCenter.hidden = true;
    styleView.hidden = false;
    document.documentElement.classList.remove('gettmi-profile-open');
    showMain();
    loadStyleProfile();
  }

  function closeStyleProfile() {
    var settings = settingsRoot();
    var styleView = view();
    if (!settings || !styleView) return;
    styleView.hidden = true;
    settings.querySelector('[data-gettmi-profile]').hidden = false;
    document.documentElement.classList.add('gettmi-profile-open');
  }

  function optionLabel(dimension, value) {
    var match = (state.options[dimension] || []).find(function (option) {
      return option.value === value;
    });
    return match ? match.label : value;
  }

  function selectionSummary(values, dimension, fallback) {
    var labels = asArray(values).map(function (value) {
      return dimension ? optionLabel(dimension, value) : value;
    });
    if (!labels.length) return fallback || 'Not set';
    if (labels.length <= 2) return labels.join(', ');
    return labels.slice(0, 2).join(', ') + ' +' + (labels.length - 2);
  }

  function readiness() {
    var checks = {
      brands: Boolean(state.selected.brands.length),
      creators: Boolean(state.selected.creators.length || state.selected.suggestedCreators.length),
      openingFeed: Boolean(state.selected.openingFeed.length),
      sizes: Boolean(state.selected.sizes.length || state.selected.shoeSizes.length),
      occasions: Boolean(state.selected.occasions.length),
      budget: Boolean(state.selected.budgets.length)
    };
    var complete = Object.keys(checks).filter(function (key) { return checks[key]; }).length;
    return {
      checks: checks,
      ready: complete === Object.keys(checks).length,
      score: Math.round(complete / Object.keys(checks).length * 100)
    };
  }

  function renderAvatar() {
    var styleView = view();
    if (!styleView) return;
    var profile = state.profile || {};
    var avatar = styleView.querySelector('[data-gettmi-style-avatar]');
    var initial = styleView.querySelector('[data-gettmi-style-initial]');
    var initialValue = String(profile.username || profile.first_name || profile.last_name || profile.email || 'G').trim().charAt(0).toUpperCase() || 'G';
    initial.textContent = initialValue;
    if (profile.profile_photo_url) {
      avatar.src = profile.profile_photo_url;
      avatar.hidden = false;
      initial.hidden = true;
    } else {
      avatar.removeAttribute('src');
      avatar.hidden = true;
      initial.hidden = false;
    }
  }

  function renderMainSummaries() {
    var styleView = view();
    if (!styleView) return;
    var ready = readiness();
    styleView.querySelector('[data-gettmi-style-score]').textContent = ready.score + '%';
    styleView.querySelector('[data-gettmi-style-progress]').style.width = ready.score + '%';

    var summaries = {
      brands: selectionSummary(state.selected.brands, '', 'Add your favourite labels'),
      openingFeed: selectionSummary(state.selected.openingFeed, 'opening_feed', 'Choose what you want to see first'),
      sizes: selectionSummary(
        state.selected.sizes.map(function (value) { return optionLabel('clothing_size', value); })
          .concat(state.selected.shoeSizes.map(function (value) { return optionLabel('shoe_size', value); })),
        '',
        'Not set'
      ),
      occasions: selectionSummary(state.selected.occasions, 'occasion', 'Not set'),
      colours: selectionSummary(
        state.selected.colours.map(function (value) { return optionLabel('colour', value); })
          .concat(state.selected.details.map(function (value) { return optionLabel('detail', value); })),
        '',
        'Not set'
      ),
      fit: selectionSummary(state.selected.fit, 'fit', 'Not set'),
      budget: selectionSummary(state.selected.budgets, 'budget', 'Choose your range'),
      notMyStyle: selectionSummary(state.selected.dislikes, 'dislike', 'Not set')
    };
    Object.keys(summaries).forEach(function (key) {
      var summary = styleView.querySelector('[data-gettmi-style-summary="' + key + '"]');
      if (summary) summary.textContent = summaries[key];
    });
    Object.keys(ready.checks).forEach(function (key) {
      var attention = styleView.querySelector('[data-gettmi-style-attention="' + key + '"]');
      if (attention) attention.hidden = Boolean(ready.checks[key]);
    });
    var creatorSummary = styleView.querySelector('[data-gettmi-creator-summary]');
    creatorSummary.textContent = state.selected.creators.length
      ? state.selected.creators.length + ' selected'
      : 'Add or update your favourite creators and style icons.';
    renderAvatar();
  }

  function initialiseSelected(profile) {
    state.selected = {
      brands: asArray(profile.favourite_brands),
      budgets: asArray(profile.budgets),
      colours: asArray(profile.colours),
      creators: asArray(profile.favourite_creator_ids),
      details: asArray(profile.style_details),
      dislikes: asArray(profile.not_my_style),
      fit: asArray(profile.fit_preferences),
      occasions: asArray(profile.occasions),
      openingFeed: asArray(profile.opening_feed),
      shoeSizes: asArray(profile.shoe_sizes),
      sizes: asArray(profile.sizes),
      suggestedCreators: asArray(profile.suggested_creator_handles)
    };
  }

  function loadStyleProfile() {
    if (styleProfileGated()) return;
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id || state.loading) return;
    if (state.loaded) {
      renderMainSummaries();
      renderCreators();
      return;
    }
    state.loading = true;
    var profileSelect = 'id,email,first_name,last_name,username,profile_photo_url,opening_feed,favourite_brands,favourite_creator_ids,suggested_creator_handles,sizes,shoe_sizes,occasions,colours,style_details,fit_preferences,budgets,not_my_style,style_profile_ready,phone,date_of_birth';
    var profileRequest = window.fetch(
      cfg.url + '/rest/v1/profiles?select=' + profileSelect + '&id=eq.' + encodeURIComponent(currentSession.user_id) + '&limit=1',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    });
    var optionRequest = window.fetch(
      cfg.url + '/rest/v1/style_profile_options?select=dimension,option_key,profile_value,label,sort_order,aliases,metadata&order=dimension.asc,sort_order.asc',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) return [];
      return response.json();
    });
    var brandRequest = window.fetch(
      cfg.url + '/rest/v1/brand_profiles?select=vendor,display_name&is_active=eq.true&order=display_name.asc',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) return [];
      return response.json();
    });
    var creatorRequest = window.fetch(
      cfg.url + '/rest/v1/creator_directory?select=creator_id,display_name,handle,avatar_url,vibe,search_aliases,sort_order,is_featured&status=eq.active&order=is_featured.desc,sort_order.asc,display_name.asc',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) return [];
      return response.json();
    });

    Promise.all([profileRequest, optionRequest, brandRequest, creatorRequest]).then(function (results) {
      state.profile = results[0] && results[0][0] ? results[0][0] : {
        id: currentSession.user_id,
        email: currentSession.email || ''
      };
      if (!state.profile.email) state.profile.email = currentSession.email || '';
      initialiseSelected(state.profile);
      state.options = {};
      (results[1] || []).forEach(function (row) {
        if (!state.options[row.dimension]) state.options[row.dimension] = [];
        state.options[row.dimension].push({
          key: row.option_key,
          label: row.label,
          value: row.profile_value
        });
      });
      state.brands = Array.from(new Set((results[2] || []).map(function (row) {
        return row.vendor || row.display_name;
      }).filter(Boolean).concat(state.selected.brands))).sort(function (a, b) {
        return a.localeCompare(b);
      });
      state.creators = (results[3] || []).map(function (row) {
        return {
          aliases: asArray(row.search_aliases),
          avatar: row.avatar_url || '',
          featured: Boolean(row.is_featured),
          handle: row.handle || '',
          id: row.creator_id,
          name: row.display_name || row.handle || '',
          vibe: row.vibe || ''
        };
      }).filter(function (creator) {
        return creator.id && creator.name && creator.handle;
      });
      state.loaded = true;
      renderMainSummaries();
      renderCreators();
    }).catch(function () {
      setSaveStatus('Style profile could not load right now.');
    }).finally(function () {
      state.loading = false;
    });
  }

  function markUnsaved() {
    state.unsaved = true;
    setSaveStatus('');
    var saveBar = view() && view().querySelector('[data-gettmi-style-save-bar]');
    if (saveBar) saveBar.hidden = false;
    renderMainSummaries();
  }

  function chipButton(value, label, selectedKey) {
    var button = el('button', 'gettmi-style-profile__chip', label);
    button.type = 'button';
    button.dataset.gettmiStyleChoice = value;
    button.dataset.gettmiStyleSelected = selectedKey;
    button.classList.toggle('is-active', state.selected[selectedKey].indexOf(value) !== -1);
    return button;
  }

  function appendChipGroup(container, label, values, selectedKey, dimension) {
    if (label) container.appendChild(el('h4', '', label));
    var grid = el('div', 'gettmi-style-profile__chips');
    values.forEach(function (item) {
      var value = typeof item === 'string' ? item : item.value;
      var textValue = typeof item === 'string' ? item : item.label;
      grid.appendChild(chipButton(value, textValue, selectedKey, dimension));
    });
    container.appendChild(grid);
  }

  function showDetail(key) {
    var definition = sectionDefinitions[key];
    var styleView = view();
    if (!definition || !styleView) return;
    state.activeSection = key;
    styleView.querySelector('[data-gettmi-style-main]').hidden = true;
    styleView.querySelector('[data-gettmi-style-detail]').hidden = false;
    styleView.querySelector('[data-gettmi-style-title]').textContent = definition.title;
    styleView.querySelector('[data-gettmi-style-detail-title]').textContent = definition.title;
    var choices = styleView.querySelector('[data-gettmi-style-choices]');
    choices.replaceChildren();
    if (key === 'brands') {
      appendChipGroup(choices, '', state.brands, 'brands');
    } else if (key === 'sizes') {
      appendChipGroup(choices, 'Clothing', state.options.clothing_size || [], 'sizes');
      appendChipGroup(choices, 'Shoes', state.options.shoe_size || [], 'shoeSizes');
    } else if (key === 'colours') {
      appendChipGroup(choices, 'Colours', state.options.colour || [], 'colours');
      appendChipGroup(choices, 'Details', state.options.detail || [], 'details');
    } else {
      appendChipGroup(choices, '', state.options[definition.dimension] || [], definition.selected);
    }
    styleView.querySelector('.gettmi-style-profile__scroll').scrollTop = 0;
  }

  function showMain() {
    var styleView = view();
    if (!styleView) return;
    state.activeSection = '';
    styleView.querySelector('[data-gettmi-style-main]').hidden = false;
    styleView.querySelector('[data-gettmi-style-detail]').hidden = true;
    styleView.querySelector('[data-gettmi-style-title]').textContent = 'Style profile';
    renderMainSummaries();
    renderCreators();
  }

  function toggleChoice(button) {
    var selectedKey = button.dataset.gettmiStyleSelected;
    var value = button.dataset.gettmiStyleChoice;
    if (!selectedKey || !Object.prototype.hasOwnProperty.call(state.selected, selectedKey)) return;
    var current = state.selected[selectedKey];
    state.selected[selectedKey] = current.indexOf(value) !== -1
      ? current.filter(function (item) { return item !== value; })
      : current.concat(value);
    button.classList.toggle('is-active', state.selected[selectedKey].indexOf(value) !== -1);
    markUnsaved();
  }

  function creatorMatches(creator, query) {
    if (!query) return true;
    return [creator.name, creator.handle, creator.vibe].concat(creator.aliases || [])
      .filter(Boolean).join(' ').toLowerCase().indexOf(query) !== -1;
  }

  function creatorAvatar(creator) {
    var avatar = el('span', 'gettmi-style-profile__creator-avatar');
    if (creator.avatar) {
      var image = document.createElement('img');
      image.src = creator.avatar;
      image.alt = '';
      image.width = 56;
      image.height = 56;
      avatar.appendChild(image);
    } else {
      avatar.appendChild(el('b', '', String(creator.name || 'G').charAt(0).toUpperCase()));
    }
    return avatar;
  }

  function creatorButton(creator, featured) {
    var button = el('button', featured ? 'gettmi-style-profile__creator-card is-featured' : 'gettmi-style-profile__creator-card');
    button.type = 'button';
    button.dataset.gettmiCreator = creator.id;
    var active = state.selected.creators.indexOf(creator.id) !== -1;
    button.classList.toggle('is-active', active);
    button.appendChild(creatorAvatar(creator));
    var copy = el('span');
    copy.appendChild(el('strong', '', creator.name));
    copy.appendChild(el('small', '', creator.handle + (featured || !creator.vibe ? '' : ' · ' + creator.vibe)));
    button.appendChild(copy);
    button.appendChild(el('i', '', active ? '✓' : '♥'));
    return button;
  }

  function renderSelectedCreators() {
    var styleView = view();
    if (!styleView) return;
    var selectedWrap = styleView.querySelector('[data-gettmi-selected-creators]');
    var suggestedWrap = styleView.querySelector('[data-gettmi-suggested-creators]');
    selectedWrap.replaceChildren();
    state.selected.creators.forEach(function (id) {
      var creator = state.creators.find(function (choice) { return choice.id === id; });
      if (!creator) return;
      var pill = el('button', '', creator.handle + ' x');
      pill.type = 'button';
      pill.dataset.gettmiCreator = creator.id;
      selectedWrap.appendChild(pill);
    });
    selectedWrap.hidden = !selectedWrap.children.length;
    suggestedWrap.replaceChildren();
    state.selected.suggestedCreators.forEach(function (handle) {
      var pill = el('button', '', 'Suggested ' + handle + ' x');
      pill.type = 'button';
      pill.dataset.gettmiRemoveSuggestedCreator = handle;
      suggestedWrap.appendChild(pill);
    });
    suggestedWrap.hidden = !suggestedWrap.children.length;
    styleView.querySelector('[data-gettmi-creator-limit]').textContent = state.selected.creators.length + '/10 selected';
  }

  function renderFeaturedCreators(choices) {
    var wrap = view().querySelector('[data-gettmi-featured-creators]');
    wrap.replaceChildren();
    if (state.query) {
      wrap.hidden = true;
      return;
    }
    var featured = choices.filter(function (creator) { return creator.featured; }).slice(0, 10);
    if (!featured.length) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    wrap.appendChild(el('h4', '', 'Trending creators'));
    var rail = el('div', 'gettmi-style-profile__creator-rail');
    featured.forEach(function (creator) { rail.appendChild(creatorButton(creator, true)); });
    wrap.appendChild(rail);
  }

  function renderCreatorDirectory(choices) {
    var styleView = view();
    var list = styleView.querySelector('[data-gettmi-creator-list]');
    var suggest = styleView.querySelector('[data-gettmi-suggest-creator]');
    list.replaceChildren();
    var available = choices.filter(function (creator) {
      return state.selected.creators.indexOf(creator.id) === -1;
    });
    var groups = {};
    available.forEach(function (creator) {
      var key = state.creatorMode === 'category'
        ? (creator.vibe || 'Style creators')
        : String(creator.name || '#').charAt(0).toUpperCase();
      if (!groups[key]) groups[key] = [];
      groups[key].push(creator);
    });
    Object.keys(groups).sort().forEach(function (key) {
      var section = el('section');
      section.appendChild(el('h4', '', key));
      groups[key].forEach(function (creator) {
        section.appendChild(creatorButton(creator, false));
      });
      list.appendChild(section);
    });
    if (!available.length) {
      list.appendChild(el('p', 'gettmi-style-profile__creator-empty', state.query ? 'No creators found yet.' : 'No creators available yet.'));
    }
    var cleanHandle = state.query ? (state.query.charAt(0) === '@' ? state.query : '@' + state.query) : '';
    var exact = choices.some(function (creator) {
      return String(creator.handle || '').toLowerCase() === cleanHandle.toLowerCase();
    });
    suggest.hidden = !cleanHandle || exact || state.selected.suggestedCreators.indexOf(cleanHandle) !== -1;
    suggest.textContent = 'Suggest ' + cleanHandle;
    suggest.dataset.gettmiSuggestCreator = cleanHandle;
  }

  function renderCreators() {
    var styleView = view();
    if (!styleView) return;
    var query = state.query.trim().toLowerCase();
    var choices = state.creators.filter(function (creator) { return creatorMatches(creator, query); });
    renderSelectedCreators();
    renderFeaturedCreators(choices);
    renderCreatorDirectory(choices);
    styleView.querySelectorAll('[data-gettmi-creator-mode]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.gettmiCreatorMode === state.creatorMode);
    });
    renderMainSummaries();
  }

  function toggleCreator(id) {
    var current = state.selected.creators;
    if (current.indexOf(id) !== -1) {
      state.selected.creators = current.filter(function (creatorId) { return creatorId !== id; });
    } else if (current.length < 10) {
      state.selected.creators = current.concat(id);
    }
    markUnsaved();
    renderCreators();
  }

  function suggestCreator(handle) {
    var clean = String(handle || '').trim().replace(/^@?/, '@');
    if (!clean || state.selected.suggestedCreators.indexOf(clean) !== -1) return;
    state.selected.suggestedCreators = state.selected.suggestedCreators.concat(clean);
    state.query = '';
    var input = view().querySelector('[data-gettmi-creator-query]');
    if (input) input.value = '';
    markUnsaved();
    renderCreators();
  }

  function setSaveStatus(message) {
    var styleView = view();
    if (!styleView) return;
    var bar = styleView.querySelector('[data-gettmi-style-save-bar]');
    var status = styleView.querySelector('[data-gettmi-style-save-status]');
    status.textContent = message || '';
    status.hidden = !message;
    bar.hidden = !message && !state.unsaved;
  }

  function updateSharedProfileUi() {
    var settings = settingsRoot();
    if (!settings) return;
    var ready = readiness();
    var attention = settings.querySelector('[data-gettmi-profile-attention]');
    var dot = settings.querySelector('[data-gettmi-style-attention]');
    if (attention) attention.hidden = ready.ready;
    if (dot) dot.hidden = ready.ready;
    var accountAvatar = settings.querySelector('[data-gettmi-account-avatar]');
    var accountInitial = settings.querySelector('[data-gettmi-account-initial]');
    if (accountAvatar) {
      accountAvatar.src = state.profile.profile_photo_url || '';
      accountAvatar.hidden = !state.profile.profile_photo_url;
    }
    if (accountInitial) accountInitial.hidden = Boolean(state.profile.profile_photo_url);
    document.dispatchEvent(new CustomEvent('gettmi:profile-updated', {
      detail: { profile: state.profile, session: session() }
    }));
  }

  function saveStyleProfile() {
    if (styleProfileGated()) return;
    var cfg = config();
    var currentSession = session();
    var styleView = view();
    var button = styleView && styleView.querySelector('[data-gettmi-style-save]');
    if (!cfg || !currentSession || !button || !state.unsaved) return;
    var ready = readiness();
    var profile = state.profile || {};
    var payload = {
      id: currentSession.user_id,
      budgets: state.selected.budgets,
      colours: state.selected.colours,
      email: profile.email || currentSession.email || '',
      favourite_brands: state.selected.brands,
      favourite_creator_ids: state.selected.creators,
      first_name: profile.first_name || '',
      fit_preferences: state.selected.fit,
      last_name: profile.last_name || '',
      not_my_style: state.selected.dislikes,
      occasions: state.selected.occasions,
      opening_feed: state.selected.openingFeed,
      phone: profile.phone || '',
      profile_photo_url: profile.profile_photo_url || null,
      shoe_sizes: state.selected.shoeSizes,
      sizes: state.selected.sizes,
      style_details: state.selected.details,
      style_profile_ready: ready.ready,
      suggested_creator_handles: state.selected.suggestedCreators,
      updated_at: new Date().toISOString(),
      username: profile.username || String(currentSession.email || '').split('@')[0]
    };
    if (profile.date_of_birth) payload.date_of_birth = profile.date_of_birth;
    button.disabled = true;
    button.textContent = 'Saving...';
    setSaveStatus('Saving...');
    window.fetch(cfg.url + '/rest/v1/profiles?on_conflict=id', {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates,return=representation'
      }),
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      state.profile = rows && rows[0] ? rows[0] : Object.assign({}, profile, payload);
      state.unsaved = false;
      setSaveStatus('Changes saved.');
      renderMainSummaries();
      updateSharedProfileUi();
    }).catch(function () {
      setSaveStatus('Could not save changes. Try again.');
    }).finally(function () {
      button.disabled = false;
      button.textContent = 'Save changes';
    });
  }

  function uploadProfilePhoto(file) {
    if (styleProfileGated()) return;
    var cfg = config();
    var currentSession = session();
    var styleView = view();
    var status = styleView && styleView.querySelector('[data-gettmi-style-photo-status]');
    var avatar = styleView && styleView.querySelector('[data-gettmi-style-avatar]');
    var initial = styleView && styleView.querySelector('[data-gettmi-style-initial]');
    if (!cfg || !currentSession || !file || !status || !avatar) return;
    if (file.size > 5 * 1024 * 1024) {
      status.textContent = 'Choose a photo under 5MB.';
      return;
    }
    var extension = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
    var path = currentSession.user_id + '/avatar.' + extension;
    var previewUrl = URL.createObjectURL(file);
    avatar.src = previewUrl;
    avatar.hidden = false;
    initial.hidden = true;
    status.textContent = 'Uploading photo…';
    window.fetch(cfg.url + '/storage/v1/object/avatars/' + path, {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': file.type || 'image/jpeg',
        'x-upsert': 'true'
      }),
      body: file
    }).then(function (response) {
      if (!response.ok) throw new Error();
      state.profile.profile_photo_url = cfg.url + '/storage/v1/object/public/avatars/' + path + '?v=' + Date.now();
      avatar.src = state.profile.profile_photo_url;
      status.textContent = 'Profile photo ready to save.';
      markUnsaved();
    }).catch(function () {
      renderAvatar();
      status.textContent = 'Photo could not upload right now.';
    }).finally(function () {
      URL.revokeObjectURL(previewUrl);
    });
  }

  function resetStyleOwnerState() {
    state.activeSection = '';
    state.brands = [];
    state.creatorMode = 'az';
    state.creators = [];
    state.loaded = false;
    state.loading = false;
    state.options = {};
    state.profile = {};
    state.query = '';
    state.unsaved = false;
    state.selected = {
      brands: [],
      budgets: [],
      colours: [],
      creators: [],
      details: [],
      dislikes: [],
      fit: [],
      occasions: [],
      openingFeed: [],
      shoeSizes: [],
      sizes: [],
      suggestedCreators: []
    };
    var styleView = view();
    if (!styleView) return;
    styleView.hidden = true;
    styleView.querySelector('[data-gettmi-style-save-bar]').hidden = true;
    styleView.querySelector('[data-gettmi-style-save-status]').hidden = true;
    var queryInput = styleView.querySelector('[data-gettmi-creator-query]');
    if (queryInput) queryInput.value = '';
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest('[data-gettmi-open-style-profile]')) {
      openStyleProfile();
      return;
    }
    if (!target.closest('[data-gettmi-style-profile]')) return;
    if (target.closest('[data-gettmi-style-back]')) {
      if (state.activeSection) showMain();
      else closeStyleProfile();
      return;
    }
    var section = target.closest('[data-gettmi-style-section]');
    if (section) {
      showDetail(section.dataset.gettmiStyleSection);
      return;
    }
    var choice = target.closest('[data-gettmi-style-choice]');
    if (choice) {
      toggleChoice(choice);
      return;
    }
    var creator = target.closest('[data-gettmi-creator]');
    if (creator) {
      toggleCreator(creator.dataset.gettmiCreator);
      return;
    }
    var removeSuggestion = target.closest('[data-gettmi-remove-suggested-creator]');
    if (removeSuggestion) {
      state.selected.suggestedCreators = state.selected.suggestedCreators.filter(function (handle) {
        return handle !== removeSuggestion.dataset.gettmiRemoveSuggestedCreator;
      });
      markUnsaved();
      renderCreators();
      return;
    }
    var mode = target.closest('[data-gettmi-creator-mode]');
    if (mode) {
      state.creatorMode = mode.dataset.gettmiCreatorMode;
      renderCreators();
      return;
    }
    var suggestion = target.closest('[data-gettmi-suggest-creator]');
    if (suggestion) {
      suggestCreator(suggestion.dataset.gettmiSuggestCreator);
      return;
    }
    if (target.closest('[data-gettmi-style-save]')) {
      saveStyleProfile();
      return;
    }
    if (target.closest('[data-gettmi-style-photo-button]')) {
      view().querySelector('[data-gettmi-style-photo-input]').click();
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-gettmi-creator-query]')) return;
    state.query = event.target.value;
    renderCreators();
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-gettmi-style-photo-input]')) return;
    var file = event.target.files && event.target.files[0];
    if (file) uploadProfilePhoto(file);
    event.target.value = '';
  });

  document.addEventListener('gettmi:signed-in', resetStyleOwnerState);
  document.addEventListener('gettmi:signed-out', resetStyleOwnerState);
})();
